module.exports = __webpack_public_path__ + "img/skyline.859aa7e.svg";